import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import { IconButton, Tooltip, alpha, useTheme } from "@mui/material";

interface AnalyzeContextButtonProps {
    productName: string;
    onAnalyze: () => void;
    compact?: boolean;
}

const AnalyzeContextButton = ({ productName, onAnalyze, compact = false }: AnalyzeContextButtonProps) => {
    const theme = useTheme();
    const size = compact ? 24 : 28;
    return (
        <Tooltip title="Analyze Context" arrow>
            <IconButton
                size="small"
                aria-label={`Analyze Context for ${productName}`}
                onClick={event => {
                    event.stopPropagation();
                    onAnalyze();
                }}
                sx={{
                    width: size,
                    height: size,
                    color: theme.palette.primary.main,
                    flex: "0 0 auto",
                    "&:hover": {
                        backgroundColor: alpha(theme.palette.primary.main, 0.09)
                    }
                }}
            >
                <AutoAwesomeOutlinedIcon sx={{ fontSize: compact ? 15 : 17 }} />
            </IconButton>
        </Tooltip>
    );
};

export default AnalyzeContextButton;
